<div class="card">
  <div *ngIf="!hideActions" class="card-header d-md-block d-none">
    <app-page-title [breadcrumbItems]="breadCrumbItems"/>
  </div>
  <div class="card-body">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
        <i class="ri-calendar-line me-2"></i>         {{ 'MENU.BOOKINGS' | translate }}
      </h4>
      <div class="btn-group gap-2">
        <button (click)="onAdd()" class="btn btn-outline-primary d-flex align-items-center gap-2 px-3">
          <span class="fw-bold">{{ 'BOOKINGS.IMPORT'|translate }}</span>
        </button>
        <button [disabled]="!filters.get('dateRange').value" (click)="export()" class="btn btn-primary d-flex align-items-center gap-2 px-3">
          <span class="fw-bold">{{ 'ACTIONS.EXPORT'|translate }}</span>
        </button>
      </div>
    </div>
    <form [formGroup]="filters">
      <div class="row justify-content-between d-flex gap-2">
        <div class="col-md-12 col-lg-6">
          <input
            class="form-control"
            formControlName="search"
            placeholder="{{ 'BOOKINGS.SEARCH_BOOKINGS' | translate }}"
          >
        </div>

        <div class="col-md-6 col-lg-4">
          <p-calendar
            [showIcon]="true"
            class="py-1 my-1"
            dateFormat="yy-mm-dd"
            formControlName="dateRange"
            placeholder="{{ 'DOCUMENT.DATE_RANGE' | translate }}"
            selectionMode="range"
            showClear="true"
          />
        </div>
      </div>
    </form>
  </div>

  <div class="d-flex gap-3" style="height: 100%;">
    <div [style.width.%]="100">
      <p-table
        #dt
        [hasList]="service.hasList"
        (add)="onAdd()"
        (delete)="onDelete($event)"
        (edit)="onEdit($event)"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        (onRowSelect)="onSelectBooking($event.data)"
        (onRowUnselect)="closeSidebar()"
        (view)="onView($event)"
        [(selection)]="selectedBooking"
        [columns]="service.tableColumns"
        [dataKey]="'id'"
        [first]="first"
        [globalSearch]="globalSearch"
        [hasActions]="service.hasActions"
        [hasAdd]="service.hasAdd"
        [hasDelete]="service.hasDelete"
        [hasEdit]="service.hasEdit"
        [hasView]="service.hasView"
        [loading]="loading()"
        [rows]="rows"
        [selectionMode]="'single'"
        [title]="service.title"
        [totalRecords]="total"
        [value]="list"
        paginatorPosition="bottom"
        tableStyleClass="table table-hover"
      >
        <ng-template #cells let-data>
          @for (col of service.tableColumns; track col) {
            <td>

              @switch (col.fieldName) {
                @case ('amount') {
                  <div class="d-flex align-items-center gap-2">
                    <span
                      [ngClass]="{
                        'text-primary': data.debitCredit === 'C',
                        'text-danger': data.debitCredit === 'D'
                      }"
                      class="px-2 rounded-3">
                      {{ data.amount |moneyFormat }}
                    </span>

                  </div>

                }
                @default {
                  <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                }
              }
            </td>
          }
        </ng-template>
      </p-table>

    </div>
  </div>
</div>

<sidebar [hideOnEsc]="false" [name]="sidebarName" class="code-editor-sidebar">
  <div *ngIf="sidebarIsOpened">
    <a
      (click)="closeSidebar()"
      class="btn-toggle text-dark d-flex align-items-center justify-content-center mb-4 mt-3">
      <i class="bi bi-x fs-3"></i>
    </a>

    <app-booking-assign
      (onAssigned)="this.loadData(); closeSidebar()"
      [data]="selectedBooking"
      [initialDocument]="selectedAssignment"
      [isEdit]="selectedAssignment"
    />
  </div>
</sidebar>
